import React, { useState } from "react";
import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Select,
  HStack,
  Spinner,
  Center,
  Text,
  useToast,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { useAdminReviews, Review, useDeleteReview } from "api/admin";

export default function Reviews(): JSX.Element {
  const [page, setPage] = useState(1);
  const [rating, setRating] = useState("");
  
  const { data, isLoading, isError } = useAdminReviews({ page, limit: 10, rating });
  const deleteMut = useDeleteReview();
  const toast = useToast();

  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this review?")) return;
    try {
      await deleteMut.mutateAsync(id);
      toast({ title: "Review deleted", status: "success", isClosable: true });
    } catch (e) {
      toast({ title: "Failed to delete review", status: "error", isClosable: true });
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card p="20px" mb="20px">
        <HStack mb="20px" spacing={4}>
          <Select placeholder="All Ratings" value={rating} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setRating(e.target.value)}>
            {[1,2,3,4,5].map(r => <option key={r} value={r.toString()}>{r} Stars</option>)}
          </Select>
        </HStack>

        {isLoading ? (
          <Center p="40px"><Spinner /></Center>
        ) : isError ? (
          <Center p="40px"><Text color="red.500">Failed to load data.</Text></Center>
        ) : !data?.data?.length ? (
          <Center p="40px"><Text>No data found.</Text></Center>
        ) : (
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>ID</Th>
                  <Th>Location</Th>
                  <Th>User</Th>
                  <Th>Rating</Th>
                  <Th>Comment</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.data?.map((r: Review) => (
                  <Tr key={r.id}>
                    <Td>{r.id.substring(0, 8)}</Td>
                    <Td>{r.location?.name}</Td>
                    <Td>{r.user?.fullName}</Td>
                    <Td>{r.rating} / 5</Td>
                    <Td maxW="300px" isTruncated>{r.comment}</Td>
                    <Td>
                      <Button size="sm" colorScheme="red" onClick={() => handleDelete(r.id)}>Delete</Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Flex justify="space-between" mt="4">
              <Button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</Button>
              <Text>Page {data?.page} of {(data?.totalPage || 0)}</Text>
              <Button disabled={page >= (data?.totalPage || 0)} onClick={() => setPage(p => p + 1)}>Next</Button>
            </Flex>
          </Box>
        )}
      </Card>
    </Box>
  );
}
